export default "__VITE_ASSET__DIlNGuPP__"